// extracted by mini-css-extract-plugin
module.exports = {"track":"Switch_track__XlBPN","root":"Switch_root__rDCL8"};